import { useContext, useEffect } from 'react';
import { ModalContext } from '../contexts';
import ModalItem from './ModalItem';

const ModalArea = () => {
  const { modalService, modalList } = useContext(ModalContext);

  return (
    <>
      {modalList.map((item, index) => {
        return (
          <ModalItem
            key={index}
            template={item.modalTemplate}
            param={item.modalParam}
            callBackFunc={item.callBackFunc}
            close={() => modalService.removeModal(item.modalTemplate)}
          />
        );
      })}
    </>
  );
};

export default ModalArea;
